import React, { ReactNode } from 'react';
import MoreInfoIcon from '../../../generic/UIComponents/moreInfoIcon';

// Shared by the row's control column, the dropdown toggle and its menu, so the
// three can't drift apart.
export const SETTING_CONTROL_WIDTH = '280px';

interface SettingRowProps {
  label: string;
  helpText?: string;
  /** Rendered under the control, e.g. a plan hint. */
  info?: ReactNode;
  children: ReactNode;
}

/**
 * One row per default setting. Further defaults slot in as additional
 * <SettingRow> children without touching the layout.
 *
 * Deliberately free of store access: everything arrives as props so the row can
 * be rendered in isolation, in Storybook or a test, without pulling a slice.
 */
const SettingRow: React.FC<SettingRowProps> = ({
  label,
  helpText,
  info,
  children
}) => (
  <div className="d-flex align-items-start justify-content-between gap-4 py-3">
    <div className="d-flex align-items-center pt-2">
      <span className="fw-semibold text-gray-800">{label}</span>
      {helpText && (
        <span className="ps-2">
          <MoreInfoIcon text={helpText} />
        </span>
      )}
    </div>
    <div className="flex-shrink-0" style={{ width: SETTING_CONTROL_WIDTH }}>
      {children}
      {info && <div className="mt-2">{info}</div>}
    </div>
  </div>
);

export default SettingRow;
